import addToShoppingListSlice from "@/store/addToShoppingListSlice";
import askQuestionModalSlice from "@/store/askQuestionModalSlice";
import { autoOrderToastSlice } from "@/store/autoOrderToastSlice";
import { baseApi } from "@/store/baseApi";
import cartSortSlice from "@/store/cartSortSlice";
import { sessionExpirySlice } from "@/store/sessionExpirySlice";
import { checkoutSlice } from "@/store/checkoutSlice";
import clearRefinementSlice from "@/store/clearRefinementSlice";
import compareProductsSlice from "@/store/compareProductsSlice";
import configSlice from "@/store/configSlice";
import confirmPasswordChangeSlice from "@/store/confirmPasswordChangeSlice";
import drawerMenuOpenSlice from "@/store/drawerMenuOpenSlice";
import navVisibilitySlice from "@/store/navVisibilitySlice";
import overlayDarkeningSlice from "@/store/overlayDarkeningSlice";
import productReviewToastSlice from "@/store/productReviewToastSlice";
import { recommendationsSlice } from "@/store/recommendationsSlice";
import searchDropdownVisibleSlice from "@/store/searchDropdownVisibleSlice";
import { searchSlice } from "@/store/searchSlice";
import searchViewModeSlice from "@/store/searchViewModeSlice";
import sellThisNowToastSlice from "@/store/sellThisNowToastSlice";
import variantSelectorSlice from "@/store/variantSelectorSlice";
import vendorReviewToastSlice from "@/store/vendorReviewToastSlice";
import zendeskNotificationSlice from "@/store/zendeskNotificationSlice";
import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import shoppingCartSlice from "./shoppingCartSlice";

export function makeStore() {
  return configureStore({
    reducer: {
      [baseApi.reducerPath]: baseApi.reducer,
      [shoppingCartSlice.name]: shoppingCartSlice.reducer,
      [cartSortSlice.name]: cartSortSlice.reducer,
      [searchSlice.name]: searchSlice.reducer,
      [recommendationsSlice.name]: recommendationsSlice.reducer,
      [compareProductsSlice.name]: compareProductsSlice.reducer,
      [checkoutSlice.name]: checkoutSlice.reducer,
      [addToShoppingListSlice.name]: addToShoppingListSlice.reducer,
      [confirmPasswordChangeSlice.name]: confirmPasswordChangeSlice.reducer,
      [searchViewModeSlice.name]: searchViewModeSlice.reducer,
      [variantSelectorSlice.name]: variantSelectorSlice.reducer,
      [clearRefinementSlice.name]: clearRefinementSlice.reducer,
      [drawerMenuOpenSlice.name]: drawerMenuOpenSlice.reducer,
      [navVisibilitySlice.name]: navVisibilitySlice.reducer,
      [overlayDarkeningSlice.name]: overlayDarkeningSlice.reducer,
      [searchDropdownVisibleSlice.name]: searchDropdownVisibleSlice.reducer,
      [zendeskNotificationSlice.name]: zendeskNotificationSlice.reducer,
      [configSlice.name]: configSlice.reducer,
      [vendorReviewToastSlice.name]: vendorReviewToastSlice.reducer,
      [productReviewToastSlice.name]: productReviewToastSlice.reducer,
      [askQuestionModalSlice.name]: askQuestionModalSlice.reducer,
      [sellThisNowToastSlice.name]: sellThisNowToastSlice.reducer,
      [autoOrderToastSlice.name]: autoOrderToastSlice.reducer,
      [sessionExpirySlice.name]: sessionExpirySlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
  });
}

const store = makeStore();

/** Make sure to import this like so: `import type { AppState } from "@/store/store";` */
export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action<string>>;

export default store;

export type AppStore = ReturnType<typeof makeStore>;

setupListeners(store.dispatch);
